module.exports = __webpack_public_path__ + "static/media/img_photo-tavolata.3cf70970.jpg";